export const DEFAULT_PREVIEW = 'assets/images/default-tabs-preview.png';